import { styled } from '@mui/material';
import { ReactNode } from 'react';

import { Title } from './components/Title';

const StyledPageContent = styled('div')(({ theme }) => ({
  padding: theme.spacing(8),
  borderRadius: theme.spacing(4),
  border: '1px solid #e3e3e3',
  background: '#fff',
}));

export type PageContentProps = {
  children: ReactNode;
};

export const PageContent = ({ children }: PageContentProps) => {
  return <StyledPageContent>{children}</StyledPageContent>;
};

PageContent.Title = Title;
